import { render, staticRenderFns } from "./WagtailPageHandler.vue?vue&type=template&id=1472283c"
import script from "./WagtailPageHandler.vue?vue&type=script&lang=js"
export * from "./WagtailPageHandler.vue?vue&type=script&lang=js"
import style0 from "./WagtailPageHandler.vue?vue&type=style&index=0&id=1472283c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports